import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';
import type { DataSourceRow } from 'ksnm-common-ui/lib/Table2/Table.interface';
import type { ReactElement } from 'react';

import { RoutePath } from '@components/AppRouter/constants';
import { dataControlStore } from '@stores/dataControlStore';

export const ReportVersionCell = observer(
  ({ children, content, dataRow }: { children: ReactElement; content: string; dataRow: DataSourceRow }) => {
    const { lastPagesParam, filters } = dataControlStore;

    const { organization } = filters.generalReport || {};

    const config = useMemo(
      () => ({
        organizationCode: organization,
        reportPackageCode: lastPagesParam.reportPackageCodeCm,
        reportVersionCode: dataRow.report_version,
      }),
      [dataRow, organization, lastPagesParam.reportPackageCodeCm],
    );

    const setLocalData = useCallback(
      (e) => {
        e.stopPropagation();
        localStorage.setItem('expandedTreeFromAnotherRouter', JSON.stringify({ ...config }));
      },
      [config],
    );

    return (
      <Tooltip content={content}>
        <Link
          target="_blank"
          onContextMenu={setLocalData}
          onMouseUp={setLocalData}
          onClick={setLocalData}
          to={RoutePath.REPORTING_TREE}
        >
          {children}
        </Link>
      </Tooltip>
    );
  },
);
